// // import React from 'react';

// // const managementData = [
// //   {
// //     name: 'Mr. Liaquat Ali Sher',
// //     title: 'CEO & Founder',
// //     image: '/images/ceoimage.jpg', // Replace with actual image URL
// //   },
// //   // {
// //   //   name: 'Hafiz Muhammad Abdullah Khan',
// //   //   title: 'CEO',
// //   //   image: '/images/ceo.jpg',
// //   // },
// //   {
// //     name: 'Rizwan Liaquat Ali Sher',
// //     title: 'Director',
// //     image: '/images/directer.jpeg',
// //   },
// //   {
// //     name: 'Abdur Rehman',
// //     title: 'Director',
// //     image: 'https://source.unsplash.com/200x200/?man,portrait4',
// //   },
// //   {
// //     name: 'Muhammad Ashraf',
// //     title: 'Project Manager',
// //     image: 'https://source.unsplash.com/200x200/?man,portrait5',
// //   },
// //   {
// //     name: 'Muhammad Yousaf',
// //     title: 'Admin and Accountant',
// //     image: 'https://source.unsplash.com/200x200/?man,portrait5',
// //   },
// //   {
// //     name: 'Muhammad Qasim',
// //     title: 'Site Engineer',
// //     image: 'https://source.unsplash.com/200x200/?man,portrait5',
// //   },
// //   // {
// //   //   name: 'Gohar Manzoor Khan',
// //   //   title: 'Director',
// //   //   image: 'https://source.unsplash.com/200x200/?man,portrait6',
// //   // },
// // ];

// // const ManagementProfile = () => {
// //   return (
// //     <div className="py-12 px-4 md:px-16 text-center">
// //       <h2 className="text-3xl font-bold mb-10">Management Profile</h2>
// //       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
// //         {managementData.map((member, index) => (
// //           <div key={index} className="flex flex-col items-center">
// //             <img
// //               src={member.image}
// //               alt={member.name}
// //               className="w-40 h-40 object-cover rounded-full shadow-md"
// //             />
// //             <h3 className="mt-4 font-semibold text-lg">{member.name}</h3>
// //             <p className="text-gray-700 font-medium">{member.title}</p>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default ManagementProfile;



// import React from 'react';

// const managementData = [
//   {
//     name: 'Mr. Liaquat Ali Sher',
//     title: 'CEO & Founder',
//     image: '/images/ceoimage.jpg',
//   },
//   {
//     name: 'Rizwan Liaquat Ali Sher',
//     title: 'Director',
//     image: '/images/directer.jpeg',
//     education: [
//       {
//         institute: 'CIPS - The Chartered Institute of Procurement & Supply',
//         degree: 'Postgraduate Degree, Level 6 Professional Diploma (MCIPS)',
//         years: '2015 - 2022',
//         notes: 'All exams completed. Supply Chain Management, Communication and +3 skills',
//       },
//       {
//         institute: 'ACCA',
//         degree: 'Affiliate',
//         years: '2007 - 2010',
//         notes: 'Advanced Performance Management, Advanced Audit & Assurance, Business Analysis, Corporate Reporting',
//       },
//     ],
//   },
//   {
//     name: 'Abdur Rehman',
//     title: 'Director',
//     image: 'https://source.unsplash.com/200x200/?man,portrait4',
//   },
//   {
//     name: 'Muhammad Ashraf',
//     title: 'Project Manager',
//     image: 'https://source.unsplash.com/200x200/?man,portrait5',
//   },
//   {
//     name: 'Muhammad Yousaf',
//     title: 'Admin and Accountant',
//     image: 'https://source.unsplash.com/200x200/?man,portrait5',
//   },
//   {
//     name: 'Muhammad Qasim',
//     title: 'Site Engineer',
//     image: 'https://source.unsplash.com/200x200/?man,portrait5',
//   },
// ];

// const ManagementProfile = () => {
//   return (
//     <div className="py-12 px-4 md:px-16 text-center">
//       <h2 className="text-3xl font-bold mb-10">Management Profile</h2>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
//         {managementData.map((member, index) => (
//           <div
//             key={index}
//             className="flex flex-col items-center bg-white shadow-md p-6 rounded-lg"
//           >
//             <img
//               src={member.image}
//               alt={member.name}
//               className="w-40 h-40 object-cover rounded-full shadow"
//             />
//             <h3 className="mt-4 font-semibold text-lg">{member.name}</h3>
//             <p className="text-gray-700 font-medium">{member.title}</p>

//             {member.education && (
//               <div className="mt-4 text-left">
//                 <h4 className="font-semibold text-teal-600 mb-2">Education</h4>
//                 <ul className="text-sm text-gray-600 list-disc list-inside space-y-3">
//                   {member.education.map((edu, eduIndex) => (
//                     <li key={eduIndex}>
//                       <p className="font-medium">{edu.institute}</p>
//                       <p>{edu.degree}</p>
//                       <p className="text-gray-500">{edu.years}</p>
//                       <p className="italic">{edu.notes}</p>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ManagementProfile;

import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const managementData = [
  {
    name: 'Mr. Liaquat Ali Sher',
    title: 'CEO & Founder',
    image: '/images/ceoimage.jpg',
  },
  {
    name: 'Rizwan Liaquat Ali Sher',
    title: 'Director',
    image: '/images/directer.jpeg',
    education: [
      {
        institute: 'CIPS - Chartered Institute of Procurement & Supply',
        degree: 'Postgraduate Degree, Level 6 Professional Diploma (MCIPS)',
        // description: `I am a procurement manager with over 12 years of experience...`,
      }, 
       {
        institute: 'ACCA',
        degree: 'Affiliate, Advanced Performance Management, Advanced Audit & Assurance, Business Analysis, Corporate Reporting',
        // description: `I am a procurement manager with over 12 years of experience...`,
      }, 
       {
        institute: 'Brunel University London',
        degree: 'BSc Hons in Accounting',
        // description: `I am a procurement manager with over 12 years of experience...`,
      },
    ],
  },
  {
    name: 'Zuhair Liaquat',
    title: 'Director',
    image: '/images/directer2.jpg',
    education: [
      {
        institute: 'Bahcesehir University Istanbul, Türkiye ',
        degree: 'Bachelor of Arts - BA, Architecture',
        // description: `I am a procurement manager with over 12 years of experience...`,
      }
    ],
  },
  // {
  //   name: 'Muhammad Ashraf',
  //   title: 'Project Manager',
  //   image: 'https://source.unsplash.com/200x200/?man,portrait5',
  // },
  // {
  //   name: 'Muhammad Yousaf',
  //   title: 'Admin and Accountant',
  //   image: 'https://source.unsplash.com/200x200/?man,portrait5',
  // },
  // {
  //   name: 'Muhammad Qasim',
  //   title: 'Site Engineer',
  //   image: 'https://source.unsplash.com/200x200/?man,portrait5',
  // },
];

const ManagementProfile = () => {
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const openModal = (index) => {
    setActiveModal(index);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <div className="py-12 px-4 md:px-16 text-center">
      <h2 className="text-3xl font-bold mb-10" data-aos="zoom-in" data-aos-duration="1000">
        Management Profile
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
        {managementData.map((member, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center bg-white shadow-lg rounded-lg p-6 hover:scale-[1.02] transition-transform duration-300"
            data-aos="fade-up"
            data-aos-delay={index * 100}
            data-aos-duration="800"
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-40 h-40 object-cover rounded-full shadow-md"
            />
            <h3 className="mt-4 font-semibold text-lg">{member.name}</h3>
            <p className="text-gray-700 font-medium">{member.title}</p>

            {member.education && (
              <>
                <button
                  onClick={() => openModal(index)}
                  className="mt-3 text-sm text-blue-600 hover:underline"
                >
                  View Education
                </button>

                {activeModal === index && (
                  <>
                    <div className="fixed z-50 inset-0 flex items-center justify-center p-4"
                      data-aos="zoom-in"
                      data-aos-duration="600"
                    >
                      <div className="bg-white shadow-xl border border-gray-300 p-6 rounded-xl w-full max-w-xl max-h-[90vh] overflow-y-auto relative text-left">
                        <button
                          className="absolute top-3 right-4 text-gray-500 hover:text-red-600 text-xl"
                          onClick={closeModal}
                        >
                          &times;
                        </button>
                        <h4 className="text-xl font-semibold mb-4 text-center">Education</h4>
                        {member.education.map((edu, i) => (
                          <div key={i} className="mb-5">
                            <h5 className="font-bold text-gray-800">{edu.institute}</h5>
                            <p className="text-gray-700 italic mb-2">{edu.degree}</p>
                            <p className="text-gray-600 text-sm whitespace-pre-line">{edu.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="fixed inset-0 bg-black bg-opacity-40 z-40"
                      onClick={closeModal}
                    />
                  </>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManagementProfile;
